import Splide from "@splidejs/splide";
import {Grid} from "@splidejs/splide-extension-grid";
import {fadeIn, fadeOut, slideDown, slideUp} from "./element-visibility";
import {uploadMultiple} from "./ajax";
import {addItem, openCart} from "./cart";
import {hideLoadingButton, showLoadingButton} from "../../scripts/Tools/loading-button";
import {ga4TrackSimpleEvent, sendFacebookConversionsEvent} from "./analytics";
import {hideOffcanvas} from "./offcanvas";

export function showCancelConfirmation()
{
    let confirmation = document.querySelector('#ai-tool-confirmation-close');
    fadeIn(confirmation);
}

export function hideCancelConfirmation()
{
    let confirmation = document.querySelector('#ai-tool-confirmation-close');
    fadeOut(confirmation);
}

export function closeAiTool()
{
    hideError();
    document.querySelector('#ai-tool').dataset.closing = 'true';
    hideOffcanvas('ai-tool');
    resetAiTool();
}

export function setCurrentStepDone()
{
    let buttonNext = document.querySelector('#ai-tool-next');
    let buttonAddToCart = document.querySelector('#ai-tool-add-to-cart');
    let currentStep = document.querySelector(`.ai-tool-step[data-step="${buttonNext.dataset.current}"]`);
    currentStep.dataset.done = 'true';
    switch (currentStep.dataset.button) {
        case 'next':
            buttonNext.classList.remove('disabled');
            break;
        case 'addToCart':
            buttonAddToCart.classList.remove('disabled');
            break;
    }
}

export function setCurrentStepUndone()
{
    let buttonNext = document.querySelector('#ai-tool-next');
    let buttonAddToCart = document.querySelector('#ai-tool-add-to-cart');
    let current = buttonNext.dataset.current;
    document.querySelector(`.ai-tool-step[data-step="${current}"]`).dataset.done = 'false';
    buttonNext.classList.add('disabled');
    buttonAddToCart.classList.add('disabled');
}

export function switchStep(next)
{
    hideError();
    if (next === 0){
        hideOffcanvas('ai-tool');
        return;
    }
    let toolFooter = document.querySelector('.tool-footer');
    let closeToolButton = document.querySelector('.offcanvas-header .ai-tool-close');
    let closeButton = document.querySelector('.offcanvas-header .close-tool-btn');
    let buttonNext = document.querySelector('#ai-tool-next');
    let buttonAddToCart = document.querySelector('#ai-tool-add-to-cart');
    let current = buttonNext.dataset.current;
    let currentStep = document.querySelector(`.ai-tool-step[data-step="${current}"]`);
    let nextStep = document.querySelector(`.ai-tool-step[data-step="${next}"]`);

    document.querySelector('#ai-tool').dataset.step = current;
    unselectAllUploadedImages();
    fadeOut(currentStep, 200, function() {
        currentStep.classList.remove('active');
        fadeIn(nextStep, 200, function() {
            if (nextStep) {
                nextStep.classList.add('active');
            }
            buttonNext.dataset.current = next;
            if (nextStep.dataset.done == 'false') {
                buttonNext.classList.add('disabled');
            } else {
                buttonNext.classList.remove('disabled');
            }
            switch (nextStep.dataset.button) {
                case 'next':
                    toolFooter.classList.remove('hidden');
                    closeButton.classList.remove('hidden');
                    closeToolButton.classList.add('hidden');
                    fadeOut(buttonAddToCart, 200, () => fadeIn(buttonNext));
                    break;
                case 'addToCart':
                    toolFooter.classList.remove('hidden');
                    closeButton.classList.remove('hidden');
                    closeToolButton.classList.add('hidden');
                    fadeOut(buttonNext, 200, () => fadeIn(buttonAddToCart));
                    break;
                default:
                    toolFooter.classList.add('hidden');
                    closeButton.classList.add('hidden');
                    closeToolButton.classList.remove('hidden');
                    fadeOut(buttonNext);
                    fadeOut(buttonAddToCart);
            }
            if (nextStep.classList.contains('step-images')) setTimeout(openImageExamples, 1900);
        });
    });
}

export function toggleImageExamples()
{
    let imageExamples = document.querySelector('#image-examples');
    let status = imageExamples.dataset.status;
    if (status === 'closed') {
        openImageExamples();
        ga4TrackSimpleEvent({
            event: 'avatar_tool',
            method: 'open_help'
        });
    } else if (status === 'open') {
        closeImageExamples();
        ga4TrackSimpleEvent({
            event: 'avatar_tool',
            method: 'close_help'
        });
    }
}

export function openImageExamples()
{
    let button = document.querySelector('#show-image-examples');
    let arrow = button.querySelector('.direction-icon');
    let imageExamples = document.querySelector('#image-examples');
    let status = imageExamples.dataset.status;
    let backdrop = document.querySelector('#ai-tool-backdrop');
    if (status !== 'closed') return;
    imageExamples.dataset.status = 'in-progress';
    slideDown(imageExamples, 200, function() {
        fadeIn(backdrop);
        imageExamples.dataset.status = 'open';
        arrow.classList.add('fa-rotate-180');
    });
}

export function closeImageExamples()
{
    let button = document.querySelector('#show-image-examples');
    let arrow = button.querySelector('.direction-icon');
    let imageExamples = document.querySelector('#image-examples');
    let status = imageExamples.dataset.status;
    let backdrop = document.querySelector('#ai-tool-backdrop');
    if (status !== 'open') return;
    imageExamples.dataset.status = 'in-progress';
    slideUp(imageExamples, 200, function() {
        fadeOut(backdrop);
        imageExamples.dataset.status = 'closed';
        arrow.classList.remove('fa-rotate-180');
    });
}
export function initImageExamples()
{
    let imageExamples = document.querySelectorAll('#image-examples .splide');
    imageExamples.forEach(function(splide) {
        new Splide(splide, {
            perPage: 2,
            perMove: 1,
            lazyLoad: 'sequential',
            arrows: false,
            pagination: false,
            padding: { right: '20%'},
            gap: 8,
        }).mount();
    });
}
export function initProductsInfo()
{
    let productsInfo = document.querySelector('#info-products .splide');
    new Splide(productsInfo, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        lazyLoad: 'sequential',
        arrows: true,
        pagination: false,
        padding: 0,
        gap: 0,
        autoplay: true,
        mediaQuery: 'min',
        breakpoints: {
            992: {
                perPage: 2,
                padding: { right: '25%'},
                gap: 16,
                arrows: false,
            }
        },
    }).mount();
}
export function initExamplesInfo()
{
    let examplesInfo = document.querySelector('#info-examples .splide');
    new Splide(examplesInfo, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        lazyLoad: 'sequential',
        arrows: false,
        pagination: false,
        padding: { right: '25%'},
        grid: false,
        gap: 16,
        mediaQuery: 'min',
        breakpoints: {
            992: {
                drag: false,
                padding: 0,
                grid: {
                    rows: 2,
                    cols: 4,
                },
            }
        },
    }).mount({Grid});
}

export function uploadImages(files)
{
    closeImageExamples();
    hideError();
    setUploadButtonsLoading();
    uploadMultiple(
        files,
        {
            files: files,
            onlyPrintable: true,
            ignoreErrors: true,
            prefix: 'ai-avatar',
        },
        function(data) {
            unsetUploadButtonsLoading();
            data.filesInfo.forEach(function(fileInfo) {
                showUploadedImage('/'+fileInfo.file);
            });
            updateAvatarImages();
        },
        function(error) {
            unsetUploadButtonsLoading();
            showError(error);
        }
    );
}

function setUploadButtonsLoading()
{
    document.querySelectorAll('.upload-btn').forEach(function(button) {
        button.classList.add('loading');
        button.querySelector('input[type="file"]').disabled = true;
    });
}

function unsetUploadButtonsLoading()
{
    document.querySelectorAll('.upload-btn').forEach(function(button) {
        button.classList.remove('loading');
        button.querySelector('input[type="file"]').disabled = false;
    });
}

function disableUploadButtons()
{
    document.querySelectorAll('.upload-btn').forEach(function(button) {
        button.classList.add('bg-gray-lighter');
        button.querySelector('input[type="file"]').disabled = true;
    });
}

function enableUploadButtons()
{
    document.querySelectorAll('.upload-btn').forEach(function(button) {
        button.classList.remove('bg-gray-lighter');
        button.querySelector('input[type="file"]').disabled = false;
    });
}

function showUploadedImage(image)
{
    let emptySpot = document.querySelector('.uploaded-img.empty');
    if (emptySpot) {
        let imageElement = emptySpot.querySelector('img');
        let fileInput = emptySpot.querySelector('.upload-btn');
        fileInput.classList.add('d-none');
        emptySpot.classList.remove('empty');
        emptySpot.classList.add('loading');
        emptySpot.dataset.image = image;
        imageElement.src = image;
        imageElement.classList.remove('d-none');
    }
}

export function selectUploadedImage(uploadedImg)
{
    uploadedImg.classList.add('selected');
    updateUploadedImagesControls();
}

export function unselectUploadedImage(uploadedImg)
{
    uploadedImg.classList.remove('selected');
    updateUploadedImagesControls();
}

export function unselectAllUploadedImages()
{
    document.querySelectorAll('.uploaded-img.selected').forEach((uploadedImg) => uploadedImg.classList.remove('selected'));
    updateUploadedImagesControls();
}

export function removeSelectedUploadedImages()
{
    document.querySelectorAll('.uploaded-img.selected:not(.empty)').forEach((uploadedImage) => removeUploadedImage(uploadedImage));
    updateUploadedImagesControls();
    updateAvatarImages();
}

export function removeAllUploadedImages()
{
    document.querySelectorAll('.uploaded-img:not(.empty)').forEach((uploadedImage) => removeUploadedImage(uploadedImage));
    updateUploadedImagesControls();
    updateAvatarImages();
}

function removeUploadedImage(uploadedImage)
{
    let image = uploadedImage.querySelector('img');
    let column = uploadedImage.parentElement;
    let fileInput = uploadedImage.querySelector('.upload-btn');
    let container = document.querySelector('#uploaded-images-container');
    uploadedImage.classList.add('empty');
    uploadedImage.classList.remove('selected');
    uploadedImage.dataset.image = '';
    image.src = '';
    image.classList.add('d-none');
    fileInput.classList.remove('d-none');

    container.appendChild(column);
}

function updateAvatarImages()
{
    let imagesInput = document.querySelector('#avatar-images');
    let uploadedImages = document.querySelectorAll('.uploaded-img:not(.empty)');
    let images = '';
    if (uploadedImages.length >= 7) {
        uploadedImages.forEach((uploadedImage) => images += uploadedImage.dataset.image + ',');
        images = images.replace(/,\s*$/, "");
        setCurrentStepDone();
    } else {
        setCurrentStepUndone();
    }
    if (uploadedImages.length >= 10) {
        disableUploadButtons();
    } else {
        enableUploadButtons();
    }
    imagesInput.value = images;
}

function updateUploadedImagesControls()
{
    let controls = document.querySelector('#uploaded-images-controls');
    if (document.querySelectorAll('.uploaded-img.selected').length) {
        slideDown(controls);
    } else {
        slideUp(controls);
    }
}

export function addToCart()
{
    hideError();
    let button = document.querySelector('#ai-tool-add-to-cart');
    showLoadingButton(button);

    let data = getProductData();
    addItem(
        data,
        function(items) {
            let fbqData = {
                content_type: 'product',
                content_name: '',
                content_ids: [],
                contents: [],
                value: 0,
                currency: ''
            };
            items.forEach(function(item) {
                // dataLayerAddProduct(item);
                // ecAddProduct(item.productId, item.productName, item.price, item.quantity, item.color, item.size, item.orientation);
                // ecSetAction('add');
                // trackEvent('AvatarService', 'AddToCart', item.productName);
                //
                if (window.fbq) {
                    if (!fbqData.content_name) {
                        fbqData.content_name = item.productName;
                        fbqData.currency = item.currency;
                    }
                    fbqData.content_ids.push(item.reference);
                    fbqData.value = fbqData.value + (item.price * item.quantity);
                    fbqData.contents.push({id: item.reference, quantity: item.quantity});
                }
                if (window.pintrk) {
                    pintrk('track', 'AddToCart', {
                        value: item.price,
                        order_quantity: item.quantity,
                        currency: item.currency
                    });
                }
                document.querySelectorAll('.physical-product').forEach((physicalProduct) => physicalProduct.dataset.parent = item.cartProductId)
            });
            if (window.fbq) {
                sendFacebookConversionsEvent('AddToCart', fbqData);
            }
            hideLoadingButton(button);
            closeAiTool();
            setTimeout(openCart, 500);
            // switchStep(100);
            ga4TrackSimpleEvent({
                event: 'avatar_tool',
                method: 'next_step',
                content_type: 'confirm'
            });
        },
        function(productIndex, type, message) {
            hideLoadingButton(button);
            showError(message);
        }
    )
}

export function addToCartExtra(button)
{
    hideError();
    showLoadingButton(button);
    let data = getExtraProductData(button);
    document.querySelectorAll('.physical-product').forEach((physicalProductButton) => physicalProductButton.classList.add('disabled'));
    addItem(
        data,
        function(items) {
            let fbqData = {
                content_type: 'product',
                content_name: '',
                content_ids: [],
                contents: [],
                value: 0,
                currency: ''
            };
            items.forEach(function(item) {
                // dataLayerAddProduct(item);
                // ecAddProduct(item.productId, item.productName, item.price, item.quantity, item.color, item.size, item.orientation);
                // ecSetAction('add');
                // trackEvent('AvatarService', 'AddToCart', item.productName);
                //
                if (window.fbq) {
                    if (!fbqData.content_name) {
                        fbqData.content_name = item.productName;
                        fbqData.currency = item.currency;
                    }
                    fbqData.content_ids.push(item.reference);
                    fbqData.value = fbqData.value + (item.price * item.quantity);
                    fbqData.contents.push({id: item.reference, quantity: item.quantity});
                }
                if (window.pintrk) {
                    pintrk('track', 'AddToCart', {
                        value: item.price,
                        order_quantity: item.quantity,
                        currency: item.currency
                    });
                }
            });
            if (window.fbq) {
                sendFacebookConversionsEvent('AddToCart', fbqData);
            }
            hideLoadingButton(button);
            button.classList.add('hidden');
            document.querySelector(`.physical-product-added[data-id="${data.productId}"]`).classList.remove('hidden');
        },
        function(productIndex, type, message) {
            hideLoadingButton(button);
            document.querySelectorAll('.physical-product').forEach((physicalProductButton) => physicalProductButton.classList.remove('disabled'));
            showError(message);
        }
    );
}

function getProductData()
{
    let productId = document.querySelector('#avatar-product').value;
    let options = getOptions();

    return {
        productId: productId,
        quantity: 1,
        isLocked: true,
        options: options,
    };
}

function getOptions()
{
    let options = [];
    if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) options['referrer'] = document.referrer;
    addAvatarOptions(options);
    addSizeOptions(options);

    return options;
}

function addAvatarOptions(options)
{
    options['avatarModel'] = document.querySelector('#avatar-model').value;
    options['avatarImages'] = document.querySelector('#avatar-images').value;
}

function addSizeOptions(options)
{
    options['width'] = document.querySelector('#avatar-width').value;
    options['height'] = document.querySelector('#avatar-height').value;
}

function getExtraProductData(extraProduct)
{
    return {
        productId: extraProduct.dataset.id,
        quantity: 1,
        linkToParent: true,
        parentId: extraProduct.dataset.parent,
        options: {
            width: extraProduct.dataset.width,
            height: extraProduct.dataset.height,
            device: extraProduct.dataset.device,
            composition: extraProduct.dataset.composition,
            color: extraProduct.dataset.color,
        },
    };
}

function resetAiTool()
{
    switchStep(1);
    removeAllUploadedImages();
    document.querySelectorAll('.ai-tool-step').forEach((aiToolStep) => aiToolStep.dataset.done = 'false');
    document.querySelectorAll('.ai-tool-step .selected').forEach((selection) => selection.classList.remove('selected'));
    document.querySelectorAll('.avatar-input').forEach((input) => input.value = '');
    document.querySelectorAll('.physical-product').forEach((button) => button.classList.remove('hidden', 'disabled'));
    document.querySelectorAll('.physical-product-added').forEach((button) => button.classList.add('hidden'));
}

export function showError(error)
{
    let errorContaienr = document.querySelector('#error-container');
    let errorMessage = document.querySelector('#error-message');

    errorMessage.innerHTML = error;
    slideDown(errorContaienr);
}

export function hideError()
{
    let errorContaienr = document.querySelector('#error-container');
    let errorMessage = document.querySelector('#error-message');

    errorMessage.innerHTML = '';
    slideUp(errorContaienr);
}

